import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import { StoreRootState } from "@/store";
import { hideToast } from "@/store/slices/toast.slice";

function ToastComponent() {
    const dispatch = useDispatch();
    const toast: any = useRef(null);
    const { show, data } = useSelector((state: StoreRootState) => state.toast);

    const showToast = ({
        detail = "error",
        severity = "error",
        summary = "Error",
    }) => {
        if (toast && toast.current) {
            toast.current.show({
                severity,
                summary,
                detail,
                life: 2000,
            });
        }
    };
    useEffect(() => {
        if (show) showToast(data);
        dispatch(hideToast());
    }, [show, data]);

    return (
        <>
            <Toast ref={toast} />
        </>
    );
}

export default ToastComponent;